import React, { Component } from "react";
import AppSDK from "@growthos/ui-app-sdk";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Textbox from "@acadia-ui/textbox";
import MediaMath from "../../../Helpers/MediaMathHelpers";

class InputV2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isUSCurrency: false
		};
	}

	componentDidMount() {
		if (this.props.type === "currency") {
			MediaMath.determineIfUSCurrency([AppSDK.getContext()], () => {
				this.setState({ isUSCurrency: true });
			});
		}
	}

	onChangeFunc = (event) => {
		this.props.handleInputChange(event);
	};

	render() {
		return (
			<Textbox
				disabled={this.props.readOnly}
				type={this.props.type}
				name={this.props.name}
				className={this.props.className}
				id={this.props.id.toString()}
				data-config={this.props.dataConfig}
				required={this.props.required}
				value={this.props.value}
				placeholder={this.props.placeholderText}
				onChange={this.onChangeFunc}
				pattern={this.props.pattern}
				title={this.props.title}
				error={this.props.error}
				// If it is a currency field but we are not in the US market, pass null for icon, which will remove the $ prefix
				// Otherwise if we are in the US market, pass undefined, which the Textbox component will automatically convert to a $ icon
				icon={this.state.isUSCurrency ? undefined : null}
			>
				{this.props.labelText}
				{this.props.fieldDescription && (
					<Tooltip className="field-description-tooltip" title={this.props.fieldDescription} position={TOOLTIP_POSITION.BOTTOM}>
						<i className="icon-info" />
					</Tooltip>
				)}
			</Textbox>
		);
	}
}

export default InputV2;
